<template>
  <div class="img__root">
    <template v-if="isLoading">
      <div class="loading"></div>
    </template>
    <template v-else-if="isError">
      <div v-if="showErrorImg" class="error">
        <IconMyIconLoadError></IconMyIconLoadError>
      </div>
    </template>

    <template v-if="props.imgUrl">
      <img
        :class="imgClass"
        :src="props.imgUrl"
        :alt="props.imgAlt"
        :loading="loadingHAttr"
        @load="onload"
        @error="onerror"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

const props = defineProps({
  /** 加载的图片地址 */
  imgUrl: {
    type: String,
    default: '',
  },
  imgAlt: {
    type: String,
    default: '',
  },
  imgLazyLoad: {
    type: Boolean,
    default: true,
  },
  showErrorImg: {
    type: Boolean,
    default: true,
  },
});

const loadingHAttr = computed(() => {
  return props.imgLazyLoad ? 'lazy' : 'eager';
});

/** 图片加载状态 */
const isLoading = ref(true);

/** 图片加载错误 */
const isError = ref(false);

const imgClass = computed(() => {
  return isLoading.value || isError.value ? 'img img-hide' : 'img';
});

// /**
//  * 图片加载处理
//  */
// const loadImg = () => {
//   return new Promise((res, rej) => {
//     if (!props.imgUrl) {
//       rej();
//       return;
//     }

//     const img = new Image();
//     img.onload = () => {
//       res(true);
//     };
//     img.onerror = () => {
//       rej();
//     };
//     img.src = props.imgUrl;
//   });
// };

const onload = () => {
  isLoading.value = false;
  isError.value = false;
};

const onerror = () => {
  isLoading.value = false;
  isError.value = true;
};
</script>

<style lang="scss" scoped>
@keyframes skeleton-img-loading {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

.img__root {
  display: inline-block;
  height: 100%;
  width: 100%;

  img {
    display: inline-block;
    height: 100%;
    width: 100%; // 解决 lazy loading无法触发加载图片
    object-fit: contain;
    content-visibility: auto;
    opacity: 1;
    transition: opacity 0.01s ease-out;
    &.img-hide {
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .loading {
    width: 36px;
    height: 36px;
    background: linear-gradient(270deg, rgba(198, 206, 214, 0.1) 0%, rgba(198, 206, 214, 0.3) 100%);
    border-radius: 6px;
    background-size: 200% 100%;
    will-change: background-position;
    animation: skeleton-img-loading 0.8s ease infinite;
  }
}
</style>
